export default __webpack_public_path__ + "static/media/pink-preview.34cdecb7.jpg";